module.exports = __webpack_public_path__ + "media/images/logo-white-204250dc253cc451469a84e78165eea4.svg";